import React from "react";

/**
 * Marquee — one slow editorial band. Duplicates children to loop seamlessly.
 * items: array of strings.
 */
export default function Marquee({ items, className = "" }) {
  const track = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-6 border-y border-slate-900 bg-[#070F1F] ${className}`}
    >
      <div className="marquee-track flex gap-14 whitespace-nowrap">
        {track.map((t, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-4 font-display text-2xl sm:text-3xl text-slate-400 font-light tracking-tight"
          >
            <span className="text-[#00E5FF]/70 text-lg">✦</span>
            <span>
              {t.includes("*") ? (
                <>
                  {t.split("*")[0]}
                  <em className="font-serif not-italic text-white italic">
                    {t.split("*")[1]}
                  </em>
                  {t.split("*")[2] || ""}
                </>
              ) : (
                t
              )}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
